import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as SeasonalServices from '_services/seasonal-variances-services';

const initialState = {
    status: 'idle',
    error: null,

    seasonVarianceOfIATA: {},
    duplicationResult: null,

    addSeasonalVarianceStatus: "idle",
    editSeasonalVarianceStatus: "idle",

    addSeasonalVarianceError: null,
    editSeasonalVarianceError: null,

    deleteSeasonVarianceStatus: "idle",
    deleteSeasonAdjustmentError: null,

    checkDuplicationStatus: "idle",
    checkDuplicationError: null,
}


export const getSeasonalVariance = createAsyncThunk('seasonalVariance/getSeasonalVariance', async (iata) => {
    return SeasonalServices.getSeasonalVariances(iata)
});

export const addSeasonalVariance = createAsyncThunk('seasonalVariance/addSeasonalVariance', async (details) => {
    return SeasonalServices.addSeasonalVariance(details)
});

export const editSeasonalVariance = createAsyncThunk('seasonalVariance/editSeasonalVariance', async (details) => {
    return SeasonalServices.editSeasonalVariance(details)
});

export const deleteSeasonalVariance = createAsyncThunk('seasonalVariance/deleteSeasonalVariance', async (details) => {
    return SeasonalServices.deleteSeasonalAdjustment(details)
});

export const checkDuplication = createAsyncThunk('seasonalVariance/checkDuplication', async (details) => {
    return SeasonalServices.checkDuplication(details)
});

const seasonalVarianceSlice = createSlice({
    name: 'seasonalVariance',
    initialState,
    reducers: {
        reset: (state) => initialState,
        resetStatus: (state) => {
            state.seasonVarianceOfIATA = {}
            state.addSeasonalVarianceStatus = "idle";
            state.editSeasonalVarianceStatus = "idle";
            state.deleteSeasonVarianceStatus = "idle";
            state.checkDuplicationStatus = "idle";

            state.addSeasonalVarianceError = null;
            state.editSeasonalVarianceError = null;
            state.deleteSeasonAdjustmentError = null;
            state.checkDuplicationError = null;
        }

    },
    extraReducers: {
        [getSeasonalVariance.pending]: (state, action) => {
            state.status = 'loading'
        },
        [getSeasonalVariance.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.seasonVarianceOfIATA = action.payload
        },
        [getSeasonalVariance.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        },
        [addSeasonalVariance.pending]: (state) => {
            state.addSeasonalVarianceStatus = 'loading';
        },
        [addSeasonalVariance.fulfilled]: (state, action) => {
            state.addSeasonalVarianceStatus = 'succeeded';
            state.seasonVarianceOfIATA = (action.payload);
        },
        [addSeasonalVariance.rejected]: (state, action) => {
            state.addSeasonalVarianceStatus = 'failed';
            state.addSeasonalVarianceError = action.error.message;
        },
        [editSeasonalVariance.pending]: (state) => {
            state.editSeasonalVarianceStatus = 'loading';
        },
        [editSeasonalVariance.fulfilled]: (state, action) => {
            state.editSeasonalVarianceStatus = 'succeeded';
            state.seasonVarianceOfIATA?.seasonalAdjustments.push(action.payload);
        },
        [editSeasonalVariance.rejected]: (state, action) => {
            state.editSeasonalVarianceStatus = 'failed';
            state.editSeasonalVarianceError = action.error.message;
        },
        [deleteSeasonalVariance.pending]: (state) => {
            state.deleteSeasonVarianceStatus = 'loading';
        },
        [deleteSeasonalVariance.fulfilled]: (state, action) => {
            state.deleteSeasonVarianceStatus = 'succeeded';
        },
        [deleteSeasonalVariance.rejected]: (state, action) => {
            state.deleteSeasonVarianceStatus = 'failed';
            state.deleteSeasonAdjustmentError = action.error.message;
        },
        [checkDuplication.pending]: (state) => {
            state.checkDuplicationStatus = 'loading';
        },
        [checkDuplication.fulfilled]: (state, action) => {
            state.checkDuplicationStatus = 'succeeded';
            state.duplicationResult = action.payload;
            state.checkDuplicationError = null;
        },
        [checkDuplication.rejected]: (state, action) => {
            state.checkDuplicationStatus = 'failed';
            state.checkDuplicationError = action.error.message;
        }
    }
});

export const { reset, resetStatus } = seasonalVarianceSlice.actions



export const selectSeasonalVariances = (state) => state.seasonalVariance.seasonVarianceOfIATA;
export const selectSeasonalVariancesStatus = (state) => state.seasonalVariance.status;
export const selectAddSeasonalVariancesStatus = (state) => state.seasonalVariance.addSeasonalVarianceStatus;
export const selectEditSeasonalVariancesStatus = (state) => state.seasonalVariance.editSeasonalVarianceStatus;
export const selectDeleteSeasonalVariancesStatus = (state) => state.seasonalVariance.deleteSeasonVarianceStatus;
export const selectCheckDuplicationStatus = (state) => state.seasonalVariance.checkDuplicationStatus;
export const selectCheckDuplicationError = (state) => state.seasonalVariance.checkDuplicationError;
export const selectCheckDuplicationResult = (state) => state.seasonalVariance.duplicationResult;

export default seasonalVarianceSlice.reducer;